module.exports = __webpack_public_path__ + "static/media/front-arrow-blue.5acbe107.svg";